import { createContext } from 'react';

export type AddIncidentExpenseFormModalContextProps = {
  incidentId: string | null;
  isOpen: boolean;
  openModal: (incidentId: string) => void;
  closeModal: () => void;
};

export const AddIncidentExpenseFormModalContext = createContext<AddIncidentExpenseFormModalContextProps>({
  incidentId: null,
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
});
